import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const EllipsisText = styled(Typography)<{ maxWidth?: string; sx?: any }>(
  ({ maxWidth = '180px', sx }) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth,
    ...sx,
  }),
);
